import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApp from "../context/AppContext";
import { Documento, Fornecedor, PedidoCompra } from "../types";
import { api } from "../utils/api";
import { formatQuantidade } from '../utils/functions';

const ImprimeFatura = () => {
  const { usuario, showModalError, setLoading, verificaUser, loaded, fatura } = useApp();
  const [nota, setNota] = useState<Documento>({} as Documento);
  const [pedidos, setPedidos] = useState<PedidoCompra[]>({} as PedidoCompra[]);
  const [fornecedor, setFornecedor] = useState<Fornecedor>({} as Fornecedor);
  const navigate = useNavigate();
  const getDados = () => {
    setLoading(true);
    api(usuario)
      .get("/notasServico/imprimeFatura/"+ fatura.idNota?.toString())
      .then((resp) => {
        setLoading(false);
        if (resp.status === 200) {
          setNota(resp.data.notaServico);
          setFornecedor(resp.data.fornecedor);
          setPedidos(resp.data.pedidosCompra);
        } else {
          showModalError(resp.data);
        }
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error)
        if (error.response.status === 406) {
          localStorage.clear();
          navigate("/login");
        } else if (error.response.status === 400) {
          localStorage.clear();
          navigate("/login");
          showModalError(error.response.data);
        } else showModalError("Erro ao acessar servidor");
      });
  };
  const getFatura = () => {
    getDados();
  };
  useEffect(() => {
    if (loaded) {
      verificaUser();
      if (!usuario.accessToken) navigate("/login");
      else getFatura();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);
  const pedido = pedidos[0];
  const enderecoFilial = pedido && pedido.enderecoFilial
    ? pedido.enderecoFilial
      .substring(0, pedido.enderecoFilial.indexOf(" 1"))
      .replace("RUA", "RUA ")
      .replace("ESTRADA", "ESTRADA ")
    : "";
  let cepFilial = pedido && pedido.enderecoFilial
    ? pedido.enderecoFilial.substring(pedido.enderecoFilial.indexOf(" 1") + 1, pedido.enderecoFilial.indexOf(" 1") + 9)
    : "";
  cepFilial = cepFilial.substring(0, 5) + "-" + cepFilial.substring(5, 9);
  const inscFilial = pedido && pedido.inscricaoFilial
    ? pedido.inscricaoFilial.substring(0, 3) +
    "." +
    pedido.inscricaoFilial.substring(3, 6) +
    "." +
    pedido.inscricaoFilial.substring(6, 9) +
    "." +
    pedido.inscricaoFilial.substring(9, 12)
    : "";
  let pedidosStr = "";
  let distinctPedidos: PedidoCompra[] = [];
  pedido && pedidos.map(ped => {
    if (!distinctPedidos?.find(pedido => pedido.idPedido === ped.idPedido))
      return distinctPedidos?.push(ped)
    return true;
  })
  distinctPedidos.map(pedido => pedidosStr += pedido.idPedido?.toString())
  const des = (nota?.itens && nota?.itens.length > 0) ? nota?.itens?.map(item => item.desconto).reduce((prev, next) => prev + next) : 0;
  const sub = (nota?.itens && nota?.itens.length > 0) ? nota?.itens?.map(item => item.valorTotal).reduce((prev, next) => prev + next) : 0;
  const tot = (nota?.itens && nota?.itens.length > 0) ? nota?.itens?.map(item => item.valorTotal - item.desconto).reduce((prev, next) => prev + next) : 0;
  const PedidosInfos = (pedido: PedidoCompra) => {
    return (
      <span>
        <b>PEDIDO DE COMPRA</b>: Nº {pedido.idPedido}
        {pedido.contrato && <span> - <b>CONTRATO</b>: {pedido.contrato}</span>}
        {pedido.inicioMedicao && pedido.fimMedicao && <span> - <b>MEDIÇÃO</b>: {pedido.inicioMedicao}/{pedido.fimMedicao}</span>}
        {pedido.processo && <span> - <b>PROCESSO</b>: {pedido.processo}</span>}
        <br /></span>)
  }
  const NumeroNota = () => {
    if (nota.numeroNota && nota.numeroNota !== "")
      return (
        <span>
          <b>Nº URBAM</b>: {nota.idNota}
          <br /></span>)
    else return (<></>)
  }
  const TableEndereco = () => {
    return (
      <table>
        <tfoot>
          <tr>
            <td colSpan={3}>
              <b>Endereço</b>: {fornecedor.rua}
            </td>
            <td>
              <b>Nº</b>: {fornecedor.numero}{" "}
            </td>
            <td rowSpan={4} className="modelo-fatura_urb-titulo-fatura">
              <span className="quebra-linha bold-center">FATURA </span>
              <span className="quebra-linha mod-fat-urb-alin-cent fatnumero">Nº {fatura.numeroNota?.toString().padStart(5, '0')}</span>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <b>Complemento</b>: {fornecedor.complemento}
            </td>
            <td>
              <b>Bairro</b>: {fornecedor.bairro}
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <b>Cidade</b>: {fornecedor.cidade}
            </td>
            <td>
              <b>Estado</b>: {fornecedor.estado}
            </td>
            <td>
              <b>CEP</b>: {fornecedor.cep}
            </td>
          </tr>
          <tr>
            <td>
              <b>Telefone</b>: {fornecedor.telefone}
            </td>
            <td>
              <b>CNPJ</b>: {fornecedor.cnpj}
            </td>
            <td>
              <b>IM</b>: {fornecedor.inscricaoMunicipal}
            </td>
            <td>
              <b>IE</b>: {fornecedor.inscricaoEstadual}
            </td>
          </tr>
        </tfoot>
      </table>
    );
  };
  const TableDestinatario = () => {
    return (
      <>
        <table>
          <tfoot>
            <tr>
              <td colSpan={4}>
                <span className="quebra-linha fonte-reduzida">NOME / RAZÃO SOCIAL:</span>
                <span>
                  <b>{pedido && pedido.nomeFilial}</b>{" "}
                </span>
              </td>
              <td colSpan={2}>
                <span className="quebra-linha fonte-reduzida">CNPJ/CPF:</span>
                <span>
                  <b>{pedido && pedido.cnpjFilial}</b>
                </span>
              </td>
              <td colSpan={2}>
                <span className="quebra-linha fonte-reduzida">DATA DE EMISSÃO</span>
                <span>
                  <b>{nota.dataInclusaoStr}</b>
                </span>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <span className="quebra-linha fonte-reduzida">ENDEREÇO:</span>
                <span>
                  <b>{enderecoFilial}</b>
                </span>
              </td>
              <td colSpan={2}>
                <span className="quebra-linha fonte-reduzida">BAIRRO / DISTRITO:</span>
                <span>
                  <b>VILA INDUSTRIAL</b>
                </span>
              </td>
              <td colSpan={2}>
                <span className="quebra-linha fonte-reduzida">CEP</span>
                <span>
                  <b>{cepFilial}</b>
                </span>
              </td>
            </tr>
          </tfoot>
        </table>{" "}
        <table className="tabela_valor">
          <tfoot>
            <tr>
              <td className="tab_dadosurb-tam1">
                <span className="quebra-linha fonte-reduzida">MUNICÍPIO:</span>
                <span>
                  <b>SÃO JOSÉ DOS CAMPOS</b>{" "}
                </span>
              </td>
              <td className="tab_dadosurb-tam2">
                <span className="quebra-linha fonte-reduzida">FONE / FAX:</span>
                <span>
                  <b>(12) 3908-6000</b>
                </span>
              </td>
              <td className="tab_dadosurb-tam3">
                <span className="quebra-linha fonte-reduzida">UF</span>
                <span>
                  <b>SP</b>
                </span>
              </td>
              <td className="tab_dadosurb-tam4">
                <span className="quebra-linha fonte-reduzida">INSCRIÇÃO ESTADUAL</span>
                <span>
                  <b>{inscFilial}</b>
                </span>
              </td>
            </tr>
          </tfoot>
        </table>
      </>
    );
  };
  const TableDados = () => {
    return (
      <table className="tab_prod">
        <tfoot>
          <tr>
            <td className="fonte-reduzida tab_prod-tam1">CÓDIGO</td>
            <td className="fonte-reduzida tab_prod-tam2">DESCRIÇÃO DOS PRODUTOS</td>
            <td className="fonte-reduzida tab_prod-tam3">UNID.</td>
            <td className="fonte-reduzida tab_prod-tam4">QTDE.</td>
            <td className="fonte-reduzida tab_prod-tam5">VALOR UNITÁRIO</td>
            <td className="fonte-reduzida tab_prod-tam5">DESCONTO</td>
            <td className="fonte-reduzida tab_prod-tam6">VALOR TOTAL</td>
          </tr>
          {nota?.itens && nota.itens.map((item, i) => {
            return (
              <tr className="tab_prod-ali-cen" key={i}>
                <td>{item.codigoUrbam}</td>
                <td className="tab_prod-ali-left">{item.descricao}</td>
                <td>{item.unidade}</td>
                <td>{formatQuantidade(item.quantidade)}</td>
                <td>{item.valorUnitario && item.valorUnitario.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                <td>{item.desconto ? item.desconto : (0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                <td>{item.valorTotal && item.valorTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
              </tr>
            );
          })}
        </tfoot>
      </table>
    );
  };
  const TableTotais = () => {
    return (
      <table className="tabela_valor">
        <tfoot>
          <tr>
            <td className="tab_prod_valores-tam1">
              <span className="quebra-linha fonte-reduzida">TOTAL BRUTO:</span>
              <span>
                <b>R$ {sub?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b>
              </span>
            </td>
            <td className="tab_prod_valores-tam2">
              <span className="quebra-linha fonte-reduzida">DESCONTO (R$):</span>
              <span>
                {" "}
                <b>R$ {des?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>{" "}
              </span>
            </td>
            <td className="tab_prod_valores-tam3">
              <span className="quebra-linha fonte-reduzida">VALOR TOTAL:</span>
              <span>
                <b>R$ {tot?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  };
  return (
    <>
      <div className="tabela-wrap-navegacao no-print">
        <button className="btn btn-secondary" onClick={(e) => navigate("/")}>
          Voltar
        </button>
        <input type="button" className="btn btn-primary" value="Imprimir" onClick={(e) => window.print()} />
      </div>

      <div className="modelo-fatura_urb">
        <h1>{usuario.razaoSocial}</h1>
        <TableEndereco />

        <h4>Destinatário</h4>
        <TableDestinatario />

        <h4>Dados do(s) produto(s)</h4>
        <TableDados />
        <TableTotais />

        <h4>Observações</h4>
        <div className="border border-dark faturaFooter p-2">
          <NumeroNota />
          {distinctPedidos.map(pedido => PedidosInfos(pedido))}
          {nota?.dadosAdicionais && nota.dadosAdicionais !== "" && (
            <span>
              <b>DADOS ADICIONAIS</b>: {nota.dadosAdicionais}
            </span>
          )}
          {nota && nota.vencimento &&
            <span>
              <strong>DATA DE VENCIMENTO</strong>: {(new Date(nota.vencimento || "")).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}
            </span>}
        </div>
      </div>
    </>
  );
};

export default ImprimeFatura;
